import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Phone, MessageCircle, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import FloatingWhatsApp from './FloatingWhatsApp';

const IdraulicoRomaEstCentocelle = () => {
  const handleCall = () => {
    window.location.href = 'tel:3287686356';
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/393287686356?text=Ciao,%20ho%20bisogno%20di%20un%20idraulico%20urgente%20zona%20Centocelle%20Roma%20Est.', '_blank');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Idraulico Roma Est Centocelle H24 | Pronto Intervento Urgente</title>
        <meta name="description" content="Idraulico Roma Est zona Centocelle H24. Arriviamo in 30-60 minuti anche in zone a traffico limitato. Perdite acqua, scarichi, caldaie. Tel: 328 768 6356" />
        <link rel="canonical" href={`${window.location.origin}/idraulico-roma-est-centocelle`} />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        
        <section className="bg-gradient-to-br from-blue-50 to-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center justify-center gap-2 mb-6">
                <MapPin className="h-8 w-8 text-blue-700" />
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
                  Idraulico Roma Est - Centocelle
                </h1>
              </div>
              
              <p className="text-xl text-gray-700 text-center mb-8">
                Pronto intervento idraulico H24 zona Centocelle, Prenestino, Tor Pignattara, Casilina, Alessandrino. Arriviamo in 30-60 minuti anche in zone a traffico limitato.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                <Button onClick={handleWhatsApp} size="lg" className="bg-orange-500 hover:bg-orange-600 text-white text-xl px-10 py-7">
                  <MessageCircle className="mr-3 h-7 w-7" />
                  WhatsApp Urgente
                </Button>
                <Button onClick={handleCall} size="lg" className="bg-blue-700 hover:bg-blue-800 text-white text-xl px-10 py-7">
                  <Phone className="mr-3 h-7 w-7" />
                  328 768 6356
                </Button>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Interventi Idraulici Zona Centocelle e Roma Est
                </h2>
                <p className="text-gray-700 text-lg mb-4">
                  SOS Casa Roma offre pronto intervento idraulico H24 in tutta la zona est di Roma, con particolare specializzazione nei quartieri Centocelle, Prenestino, Tor Pignattara, Casilina e Alessandrino. I nostri tecnici conoscono perfettamente la zona e intervengono rapidamente.
                </p>
                <p className="text-gray-700 text-lg mb-4">
                  <strong>Servizi offerti a Roma Est:</strong> Perdite d'acqua, scarichi intasati, tubature rotte, riparazione caldaie, sostituzione sanitari, box doccia, rubinetteria, allagamenti, ricerca perdite occulte, disostruzione scarichi.
                </p>
                <p className="text-gray-700 text-lg">
                  <strong>Zone coperte:</strong> Centocelle, Prenestino, Tor Pignattara, Casilina, Alessandrino, Quarticciolo, Gordiani, Torpignattara, Torre Spaccata, Cinecittà Est.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
        <FloatingWhatsApp />
      </div>
    </>
  );
};

export default IdraulicoRomaEstCentocelle;
